import React, { useContext } from 'react';

type KeyboardContextValue = {
  onFocus?: (id: string) => void;
  onBlur?: () => void;
  assignFieldHandle: () => void;
  getKeyListenersProps?: () => void;
};

export const KeyBoardContext = React.createContext<KeyboardContextValue>({
  onFocus: () => {},
  onBlur: () => {},
  assignFieldHandle: () => {},
  getKeyListenersProps: () => {},
});

export const useKeyBoardContext = () => {
  return useContext(KeyBoardContext);
};
